module.exports = __webpack_public_path__ + "media/images/icons/vertical_divider-cc9592fd37f2f94bd18cd5be4d8c2cfc.svg";